import React, { memo } from 'react';

const backgroundStyles = {
  white: 'bg-background',
  gray: 'bg-secondary',
  subtle: 'bg-muted/50',
  dark: 'bg-primary',
};

const accentStyles = {
  primary: 'bg-primary-100',
  secondary: 'bg-secondary',
};

// スクロール時の表示アニメーションは親の FadeInSection が担う。
// ここではセクションの余白・背景・アクセントのみを提供する。
const SectionLayout = memo(function SectionLayout({
  children,
  accent = 'primary',
  background = 'white',
  className = '',
}) {
  const bgClass = backgroundStyles[background] || backgroundStyles.white;
  const accentClass = accentStyles[accent] || accentStyles.primary;

  return (
    <div
      className={`py-16 md:py-24 relative overflow-hidden ${bgClass} ${className}`}
    >
      {accent !== 'none' && (
        <div
          className={`absolute left-0 top-0 bottom-0 w-1 ${accentClass}`}
        ></div>
      )}
      <div className="container">{children}</div>
    </div>
  );
});

export default SectionLayout;
